import React from "react";

function BlogsComponent() {
  return <div>BlogsComponent</div>;
}

export default BlogsComponent;
